var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 detailBanner"},[_c('div',{class:("banner-body " + _vm.selectPicture)},[_c('div',{staticClass:"crumb"},[_c('crumb')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }